import React from "react";
import { Body } from "../../components/text";
import { Box } from "rebass/styled-components";
import {
  StaticContentCopy,
  StaticContentTopicTitle,
  StaticContentTopicSubtitle,
} from "../../components/atoms/styledText";
import { Link } from "react-router-dom";

let QA = [
  {
    s: "General",
    q: "How do I get my CS:GO Auth codes?",
    a: `<strong>Authentication tutorial:</strong><br> Watch this short video to learn how to find and add your Match Token and Auth Codes: <a href="https://youtu.be/gJGYNG3lhEw" target="_blank" rel="noopener noreferrer">https://youtu.be/gJGYNG3lhEw</a>`,
  },
  {
    s: "General",
    q: "How do I download/install the Allstar App?",
    a: `<strong>For a new user:</strong><br> After you receive your Activation Email, click the Get Started link. After you set your password, log in, and on first log in you will be brought through our New User Onboarding flow, which will start with a link to download the app.<br><br>
    <strong>For existing users:</strong><br> Visit allstar.gg and log in to your account. Once you are logged in, you should see the “Get App” button on the upper right hand side.`,
  },
  {
    s: "General",
    q: "Can I use Allstar on Windows 7, Linux, or Mac?",
    a: `As of right now, you can only use Allstar on the <strong>Windows 10</strong> and <strong>Windows 11</strong> operating systems.`,
  },
  {
    s: "General",
    q: "What games are supported?",
    a: `<strong>Games supported:</strong><br> Currently Allstar supports CSGO, DOTA2, League of Legends, and Fortnite!
    <br><br>
    We’ll be supporting new games as soon as possible! Check out the Coming Soon tab on allstar.gg to see games on our roadmap. If you’d like to request a game, feel free to request here <a href="https://allstar.canny.io/feature-requests" target="_blank" rel="noopener noreferrer">allstar.canny.io/feature-requests</a> or on Discord.`,
  },
  {
    s: "General",
    q: "How can I add AllstarBot to my own Discord?",
    a: `<strong>AllstarBot:</strong><br> Visit <a href="https://allstar.gg/allstarbot" target="_blank" rel="noopener noreferrer">allstar.gg/allstarbot</a>, click the Add to Discord button, and follow the steps below to configure Allstarbot to your personal Discord server.`,
  },
  {
    s: "General",
    q: "Where are my clips?",
    a: `<strong>On the Desktop App:</strong><br> You can see the process of when your clips will be created by heading to the Activity Feed in the Allstar app. You can also see your clip appear in the My Content section of the Allstar app as well!<br><br>

    <strong>On Discord:</strong><br>
    Clips are automatically shared to the Allstar Discord in the #cs-clips or #dota2-clips channel about 15 minutes after your match is over. You can also have your clips sent to your own Discord server by adding the Allstarbot at <a href="https://allstar.gg/allstarbot" target="_blank" rel="noopener noreferrer">allstar.gg/allstarbot</a><br><br>
    
    <strong>On the Website:</strong><br> Log into your account, and hover over your profile in the top right. Your latest clips will all be displayed here! You might also see your clips in the clip feed or Clip of the Day!`,
  },
  {
    s: "General",
    q: "How can I get Mobile versions of my Allstar clips?  ",
    a: `<strong>Download:</strong>Find a clip you want to share on mobile, click the "9:16" button.<br><br>

    <strong>Save:</strong>Click "Save to Mobile Clips" and we'll start rendering your mobile clip.<br><br>
    <strong>Share:</strong> Head to your profile, click the "Mobile Clips" tab, and share away!<br><br>
    <strong>Note:</strong> If you do not see a Share button, your clip may be too big to automatically share. You will need to download the clip and manually upload to your destination.
    `,
  },
  {
    s: "General",
    q: "Profile Picture settings and rules?",
    a: `To help you make sure you are uploading your profile picture correctly. Here are some step-by-step instructions.<br><br>
    <strong>Check your file type:</strong>Allstar supports JPEG and PNG file formats. Profile pictures with nudity, racism and gore will be removed.<br><br>
    <strong>Check the dimensions:</strong>Recommended dimensions for profile images are 400x400 pixels.
    <br><br>
    <strong>Note:</strong> If your profile picture contains content in violation of the Allstar's Rules, we may temporarily suspend your account and remove the offending content. Repeat violations will result in a permanent suspension.
    `,
  },
  {
    s: "General",
    q: "How can I delete my clip?",
    a: `You can delete any clip by visiting your Allstar Profile, clicking on the 3 dots on any clip, and click Delete Clip.`,
  },

  {
    s: "General",
    q: "How can I download my clip?",
    a: `<strong>Clip page:</strong><br> Once your clip is complete, you can click into your clip and click on the download button in the upper right-hand side of your screen.<br><br>
    <strong>Clip Feed:</strong><br> Once your clip is complete, you can hover over your clip and click on the download button in the upper right-hand side of the clip card.`,
  },
  {
    s: "Discord",
    q: "How do I link my Discord Account?",
    a: `<strong>During activation:</strong><br> Once your account has been activated, you will be given an opportunity to link your account immediately after downloading the app.<br><br>
    <strong>From My Allstar:</strong><br> If you didn’t link your account during activation, you can link your account from My Allstar or the Desktop App.`,
  },
  {
    s: "Discord",
    q: "Does Allstar have a Discord server?",
    a: `We do! It’s a community full of gamers like yourself. Join to get involved in incredible giveaways, find other gamers to party up, and enjoy laughing at all the memes along the way! You can join our Discord here https://discord.gg/playsharestar `,
  },
  {
    s: "Allstar Studio",
    q: "What is Allstar Studio?",
    a: `Allstar Studio allows you as the creator to amplify your content with music, kill FX, memes, thumbnails, and much more!`,
  },
  {
    s: "Allstar Studio",
    q: "How does Allstar Studio work?",
    a: `In the top level navigation, click on the <a href="https://allstar.gg/studio" target="_blank" rel="noopener noreferrer">Allstar Studio</a> link. Once you are there, you can preview different music options, kill effects, and more to apply to your clips. When you find some you like, toggle them on or off!`,
  },
  {
    s: "Allstar Studio",
    q: "What happens when I have multiple options in Allstar Studio selected?",
    a: `If you have several music options, kill FX, etc. selected, we will select effects out of those options for you. <br>
    If you are looking to have specific effects on your clips, make sure only those effects are toggled on!`,
  },
  {
    s: "Allstar Studio",
    q: "How do I know what cards I have enabled?",
    a: `To check on your enabled cards, click on the number on the upper-right in Allstar Studio! You can enable, disable, or clear any cards from there as well.`,
  },
  {
    s: "Allstar Studio",
    q: "Is there a way to enable all cards or disable all cards that are selected?",
    a: `There will be 2 icons on the right hand side inside of Studio that allow you to enable all Studio cards on the page, as well as disable all Studio cards on the page.`,
  },
  {
    s: "Allstar Studio",
    q: "The Allstar Studio cards I want are being overwritten by other ones. Why is that happening?",
    a: `There are certain Creator Cards that are considered “S-Tier” cards, which will override other Creator Cards that are selected. Those “S-Tier” cards include:<br>● The Hacker <br>● What an ACE Looks Like <br>● Warm and Fuzzy <br>● VHS`,
  },
  {
    s: "Allstar Studio",
    q: "Can I use Allstar Studio on my old clips in Allstar? ",
    a: `Yes you can! Head to the clip you want to edit on your profile, click the Remix button below, and remix your clip to include any effect you would like!<br><br>Note: Since you are Remixing an Allstar clip, a brand new clip will be generated onto your profile.`,
  },
  {
    s: "Allstar Studio",
    q: "Can I use the Allstar Studio music on YouTube for my videos?",
    a: `You will need to link your YouTube Channel ID to Allstar before doing so. Go to your Account Settings under your Profile, and scroll down to the Music Licensing section.`,
  },
  {
    s: "Remix",
    q: "What does Remix do in Allstar?",
    a: `Remixing clips in Allstar allows you to change, enhance and customize ANY clip in Allstar. Forget an Allstar Studio effect to your own clip? We got you. Want to make your friend’s clip even cooler? Head to their profile and Remix! `,
  },
  {
    s: "Remix",
    q: "Where will my Remixed clips go?",
    a: `Whether you remix your own clip or some elses clip, they will appear on your Allstar profile and you will be pinged in Discord! You can always filter clips on your profile to see all Remixes.`,
  },
  {
    s: "Remix",
    q: "Why can’t I remix a Montage?",
    a: `Montages are automatically generated by Allstar with our special sauce. Because of that, there is not a way to remix or alter montages at the moment.`,
  },
  {
    s: "Remix",
    q: "What does Load Studio Preferences mean?",
    a: `Once you click on “Load Studio Preferences” it will automatically load any Allstar cards that are enabled in Studio. This makes it easy to make clips with preferences you already have selected in Allstar. `,
  },
  {
    s: "Montages",
    q: "How do I get a montage from Allstar?",
    a: `In order to get an auto-generated montage from Allstar, you’ll need to have at least 20 CSGO clips made. The montage feature is currently in BETA and is only limited to CSGO. `,
  },
  {
    s: "Montages",
    q: "Can I make manually make my own montage with Allstar?",
    a: `You cannot at the moment! We handle all the work for you. If that is something you would like in the future, leave your <a href="https://allstar.canny.io/feature-requests" target="_blank">suggestion here!</a>`,
  },
  {
    s: "Montages",
    q: "Can I add more clips to an existing montage?",
    a: `Montages are individually generated. At the moment, you cannot alter the montage once it has been created.`,
  },
  {
    s: "Allstar App",
    q: "How can I send a Bug Report in the Allstar app?",
    a: `Inside of the Allstar app, go to Settings > Troubleshoot > Submit Bug Report. Be patient as it may take some time to submit, but we will get it and get back to you soon!`,
  },
  {
    s: "Allstar App",
    q: "What does “Warning: CS:GO in Admin Mode Detected” mean in the Allstar app?",
    a: `Running any application as an Administrator gives it more power over your PC to edit, run, or otherwise modify critical system files and settings. If CS:GO is in Admin Mode, the Allstar application will also need to be in Admin Mode to interact with the game.`,
  },
  {
    s: "Allstar App",
    q: "Why is CS:GO in admin mode anyway?",
    a: `This may be because you play on a 3rd party service like Gamers Club. These services will often elevate CS:GO to administrative privilege to prevent exploits. As long as Allstar is also in admin mode as well, clipping will work as expected.<br><br>To run Allstar in Admin Mode, right click on the Allstar app, and select Run as Administrator. Head to CS:GO and create some clips! `,
  },
  {
    s: "Allstar App",
    q: "How can I set a hotkey for Allstar?",
    a: `In the Allstar app, go to Settings > Games >  Set Hotkey (CS:GO Only). From there, click into the hotkey box, select the key or key combo you would like to use, and hit Set!<br><br>
    <strong>All Chat:</strong><br>!allstar will appear in All Chat for everyone to see. <br><br>
    <strong>Team Chat:</strong><br>!allstar will only appear in the Team Chat for your teammates. <br><br>
    <strong>None (Doesn’t say !allstar):</strong><br>!allstar will not appear in any chat, but you will still hear the Allstar cheer.`,
  },
  {
    s: "Allstar App",
    q: "How do I update my Allstar app?",
    a: `When an update is ready, you should see the the option to update on the bottom left side of the app.`,
  },
  {
    s: "Allstar App",
    q: "What does the “Upload Restrictions” section mean? ",
    a: `We upload your POV demo which is recorded by the game. This section allows you to control how you upload through Allstar.<br><br> 
    <strong>Allow Uploads During Gameplay:</strong><br> Toggle this option on allows Allstar to upload your POV demos while you are still playing in the match. This allows for quicker turnaround on your clips, but it may affect your ping depending on your internet connection.<br><br>
    <strong>Limit upload bandwidth:</strong><br>By toggling this option on, you can control what speeds your internet uploads POV demos to Allstar. This can help any ping issues you experience if you are using Allstar while playing.<br><br>
    `,
  },
  {
    s: "Allstar App",
    q: "What does the “Universal CS:GO Capture” button mean?",
    a: `Allstar now supports ALL game types in CS:GO. You can now create clips in game types like Unranked, Deathmatch, Casual, and more!`,
  },
  {
    s: "Allstar App",
    q: "What does the “Enable clipping in Deathmatch and Arms Race” button mean?",
    a: `Enabling this feature will help prevent stuttering during these gamemodes. We will disable clipping in these game modes if Freezecam is not enabled to prevent any performance issues with your game. It is highly recommended to be turned on while playing Deathmatch and Arms Race!`,
  },
  {
    s: "Allstar App",
    q: "Why do I need freezecam enabled to clip in CS:GO Deathmatch and Arms Race?",
    a: `In some cases, having freezecam disabled (the console command cl_disablefreezecam 1) can cause a small stutter after each player death. Using CS:GO's default setting  (the console command cl_disablefreezecam 0) will solve this issue.<br><br>The app automatically disables Deathmatch and Arms Race clipping when it detects this command is not present, and will ask to set cl_disablefreezecam to 0 if you re-enable clipping in settings.`,
  },
  {
    s: "Allstar App",
    q: "What is the difference between “Submit Bug Report & Logs” and “Send Logs”? ",
    a: `<strong>Submit Bug Report & Logs:</strong><br> If you click this button, you will automatically be sent to our Support Form on allstar.gg, as well as send logs on your Allstar account for our support team.<br><br>
    <strong>Send Logs:</strong><br> By clicking Send Logs, you will send logging on your Allstar account to our support team to look into. Only send logs if someone from Team Allstar is aware!<br><br>`,
  },
  {
    s: "Allstar App",
    q: "How can I clip in Fortnite?",
    a: `For Allstar to capture your Fortnite clips you need to open your game settings and enable the replay options listed below. Read more about these settings in <a href="https://www.epicgames.com/fortnite/en-US/news/fortnite-battle-royale-replay-system" target="_blank">this article from Epic.</a><br>Record Replays: <strong>On</strong><br>Record Large Team Replays: <strong>On</strong><br>Record Creative Mode Replays: <strong>On</strong>`,
  },
  {
    s: "Allstar App",
    q: "The Allstar app says I’m having a “Connection Problem”, but my internet connection is fine. What’s going on?",
    a: `This could mean there is a firewall issue that is blocking the Allstar app. To fix this, make sure the Desktop App is allowed on Windows Firewall:<br>
    <br> - Navigate to "Allowed Apps" in the network settings of the windows control panel
    <br> - Select "Allow another app..."
    <br> - Select "Browse"
    <br> - Navigate to the install location for the Allstar Desktop App, typically:  C:\\Users\\YOUR-USERNAME\\AppData\\Local\\Programs\\Allstar
    <br> - Select "Allstar Desktop Application.exe"
    <br> - Select "Open"
    <br> - Select "Add"
    <br> - Confirm the boxes are checked for the appropriate networks (public and private)
    <br> - Select "OK"
    <br><br> View visual steps <a href="https://imgur.com/a/DfoWhO7" target="_blank">here</a>
    `,
  },
  {
    s: "Third Party Integrations",
    q: "Can I use Allstar on FACEIT?",
    a: `Yes! First, you will need to link your FACEIT account to Allstar.<br><br>
    <strong>Connect:</strong>To link your FACEIT account, head to your Allstar profile, then to Account Settings. Click on the FACEIT option under Linked Accounts. This will prompt you to log into FACEIT.<br><br>
    After logging into FACEIT, your account will be link with Allstar. This will also be reflected in the Allstar app, under Linked Accounts.
    `,
  },
  {
    s: "Third Party Integrations",
    q: "I found Allstar highlights clips on my Leetify matches. How do I get those clips to my Allstar profile?",
    a: `We cannot move any clips that were made in Leetify BEFORE your Allstar account was created. Any new clips that you make will be appear on your Allstar profile. `,
  },
  {
    s: "Third Party Integrations",
    q: "Allstar keeps making highlights of clips I don’t want on Leetify. What gives?",
    a: `We auto-generate clips for you based on some of your better moments in the match. If you want to make sure you get specific clips from Allstar, make sure to sign up and download the Allstar app! From there, you can manually clip your favorite moments in the match.<br><br>If there are clips you do not want from Leetify, you can always delete the clips on Allstar to ensure you only have the clips you want on your profile!`,
  },
];

export function Faq() {
  let topics = [];

  // get list of topics
  QA.map((el) => {
    if (topics.indexOf(el.s) === -1) {
      topics.push(el.s);
      return true;
    }
    return false;
  });

  // filter questions by topic
  let questions = (topic) =>
    QA.map((question, index) => {
      if (question.s !== topic) return null;

      return (
        <Box key={index} mb={8}>
          <StaticContentTopicSubtitle mb={3}>
            {question.q}
          </StaticContentTopicSubtitle>
          <Body dangerouslySetInnerHTML={{ __html: question.a }} />
        </Box>
      );
    });

  return (
    <StaticContentCopy maxWidth={6}>
      {topics.map((topic, index) => {
        return (
          <Box key={index} pr={[0, 0, 10]}>
            <StaticContentTopicTitle mb={6}>{topic}</StaticContentTopicTitle>
            {questions(topic)}
          </Box>
        );
      })}
      <hr />
      If you have a question that is not listed here, contact us on our{" "}
      <Link to="/support">support form</Link>
    </StaticContentCopy>
  );
}
